var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperY(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 64,
    viewBox: "0 0 41 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.266602 0.773679L1.55168 0L4.3885 4.71195L3.10342 5.48563L0.266602 0.773679ZM10.5889 17.9149L11.8739 17.1412L14.7108 21.8532L13.4257 22.6269L10.5889 17.9149ZM6.71281 8.57056L5.42773 9.34424L8.26456 14.0562L9.54963 13.2825L6.71281 8.57056ZM15.7363 26.4819L17.0215 25.7085L19.8575 30.4209L18.5723 31.1944L15.7363 26.4819ZM29.0432 16.4142L26.167 21.1022L27.4455 21.8866L30.3217 17.1986L29.0432 16.4142ZM20.9287 29.6342L23.8049 24.9461L25.0835 25.7306L22.2073 30.4186L20.9287 29.6342ZM34.2766 7.90085L31.4004 12.5889L32.6789 13.3733L35.5551 8.68527L34.2766 7.90085ZM36.623 4.06213L38.9933 0.201739L40.2716 0.986603L37.9013 4.84699L36.623 4.06213ZM20.8896 32.2262H19.3896V35.7262H20.8896V32.2262ZM19.3896 50.1262H20.8896V55.6062H19.3896V50.1262ZM20.8896 40.1862H19.3896V45.6662H20.8896V40.1862ZM19.3896 60.0662H20.8896V63.5662H19.3896V60.0662Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperY);
export default __webpack_public_path__ + "static/media/UPPER_Y.6aab7070eda755d9de9e0554a5090615.svg";
export { ForwardRef as ReactComponent };